import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M27,5.6H5A2.65,2.65,0,0,0,2.35,8.25v15.5A2.65,2.65,0,0,0,5,26.4H27a2.65,2.65,0,0,0,2.65-2.65V8.25A2.65,2.65,0,0,0,27,5.6ZM5,6.9H27a1.35,1.35,0,0,1,1.35,1.35v15.5a2.16,2.16,0,0,1-.05.27L20.65,16.5a.64.64,0,0,0-.91,0L16.23,20,11,14.31a.64.64,0,0,0-.47-.21h0a.66.66,0,0,0-.46.19L3.65,20.72V8.25A1.35,1.35,0,0,1,5,6.9ZM5,25.1a1.35,1.35,0,0,1-1.35-1.35V22.57l6.81-6.88,5.27,5.71a.63.63,0,0,0,.47.2c.16.06.34-.06.47-.18l3.53-3.54L27.45,25a1.34,1.34,0,0,1-.45.09Z' }),
  React.createElement('path', { d: 'M22.38,14.67A2.42,2.42,0,1,0,20,12.25,2.42,2.42,0,0,0,22.38,14.67Zm0-3.54a1.12,1.12,0,1,1-1.13,1.12A1.12,1.12,0,0,1,22.38,11.13Z' }),
  React.createElement('g', { id: 'Artboard-32' })
));